import { FC } from "react"
import { createSearchParams, Link } from "react-router-dom";
import { KAMsList, KAMsListObjectType } from "../TBMsRBDsFRMs/types";

const KAMs: FC<KAMsList> = ({ data,ecr_total,case_total ,defaultQueryParams,updateQueryParams}): JSX.Element => {

  const handleLinkClick = (item:KAMsListObjectType) => {
    sessionStorage.setItem(
      "territoryState",
      JSON.stringify({
        type: "territories",
        role: item.role,
        id: item.id,
      })
    )}

  return (
    <div className="card p-0">
      <div className="d-flex flex-column flex-fill">
        <div className="card-header bg-success-subtle order-1">
          <h4 className="mb-0 p-0 text-black text-center">KAMs</h4>
        </div>
        <div className="order-2 card-body p-0 overflow-y-auto" style={{ maxHeight: 400 }}>
          <table className="table table-responsive table-hover">
            <thead className="table-light sticky-top">
              <tr className={"text-center"}>
                <th scope="col">Name</th>
                <th scope="col">Cases</th>
                <th scope="col">ECR</th>
              </tr>
            </thead>
            <tbody>
              {data && data.length > 0 &&
                data.map((item, key) =>
                  <tr className={"text-center"} key={key}>
                    <td>
                      <Link 
                      // to={{ 
                      //   pathname: '/territories', 
                      //   search: objectToQueryString({

                      //     id: item.id,
                      //     type: "territories",
                      //     role: item.role,
                      //   })
                        
                      // }} 
                       
                      state={{ type: "territories" ,role:item.role , id:item.id}}
                      to={{
                        pathname:`/territories/${item.id}`,
                        search: createSearchParams({
                            role: item.role,
                            type: "territories",
                            id:item.id.toString(),
                            start_date:defaultQueryParams?.start_date || "",
                            end_date:defaultQueryParams?.end_date || "",
                            period:defaultQueryParams?.period || "",
                            filter_type:defaultQueryParams?.filter_type || "",
                        }).toString()
                    }} 
                    onClick={()=>{handleLinkClick(item)}}
                    reloadDocument={true} className="fw-normal fs-6 btn-link link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover" >{item?.name} </Link>
                    </td>
                    <td>{item?.cases}</td>
                    <td>{item?.ecr}</td>
                  </tr>
                )
              }
            </tbody>
            <tfoot>
              <tr>
                <td className="fw-bold text-center">Total</td>
                <td className="fw-bold text-center">{case_total}</td>
                <td className="fw-bold text-center">{ecr_total}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
};
export default KAMs;